import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { toastr } from 'react-redux-toastr';
import { Row, Col, FormGroup, FormLabel, FormControl } from 'react-bootstrap';
import { IoMdColorFill } from "react-icons/io";
import { FiDelete, FiCalendar } from "react-icons/fi";
import { TwitterPicker } from 'react-color';
import { showModal, hideModal } from "actions/modalActions";
import Avatars from 'components/Avatar/Avatars';
import Switch from "components/Switch";
import GroupsMultiSelect from "components/Groups/GroupsMultiSelect";
import { groupsService } from "services";
import { errorFormating, hasSubscriptionFeature } from "utils/utils";
import moment from 'moment';
import UpgradeModal from 'components/Modal/UpgradeModal';
import { withTranslation } from 'react-i18next';
import EmployeePlanOpenerModal from 'components/Employees/EmployeePlanOpenerModal';

import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es"; // datepicker locale
registerLocale("es", es);

class GroupInfo extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);

		const group = this.props.group;

		if (group.calendar)
			group.calendar_id = group.calendar.id;

		this.state = {
			group,
			prevGroup: group,
			isPickerVisible: false,
			errors: {},
			error_footer: '',
			selected_groups: group.groups || [],
			new_item_error: false,
			showUpgradeModal: false,
			upgradeFeature: '',
		};

		this.closeModal = this.closeModal.bind(this);
		this.openDeleteModal = this.openDeleteModal.bind(this);
		this.openPlanModal = this.openPlanModal.bind(this);
	}

	closeModal() {
		this.props.hideModal()
	}

	openPlanModal() {
		const { group } = this.state;
		
		// Período predeterminado: semana actual (lunes a domingo)
		const start = moment().startOf('isoWeek').format("YYYY-MM-DD"); // Lunes (ISO week)
		const end = moment().endOf('isoWeek').format("YYYY-MM-DD"); // Domingo (ISO week)

		this.props.showModal(
			{
				open: true,
				title: this.props.t('groups.info.planTitle'),
				style: { width: "460px" },
				content: (
					<EmployeePlanOpenerModal
						group_id={group.id || ""}
						start={start}
						end={end}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openDeleteModal() {
		this.props.showModal({
			open: true,
			title: this.props.t('groups.deleteGroup'),
			style: { width: '400px' },
			message: this.props.t('groups.deleteConfirmation'),
			deleteAction: this.confirmDelete,
			closeModal: this.closeModal
		}, 'delete')
	}

	handleChange = event => {
		const { group } = this.state;
		const target = event.target.id;
		let value = event.target.value;

		if (target === "temp_group") {
			return;
		}

		// normal group change
		this.setState({
			prevGroup: group,
			group: {
				...group,
				[event.target.id]: value
			}
		});
	}

	handleSelectedGroupsChange = (ids) => {
		const idSet = new Set(ids.map(String));
		const selected_groups = (this.props.select_groups || []).filter((item) =>
			idSet.has(String(item.id))
		);

		this.setState(
			{
				selected_groups,
				new_item_error: false,
			},
			() => {
				this._saveGroup();
			}
		);
	}

	handleSwitch = event => {
		const { group } = this.state;
		const target = event.target.id;

		// Verificar si es el switch de two_levels_workflow y si tiene acceso
		if (target === 'two_levels_workflow' && !hasSubscriptionFeature('TWO_LEVEL_APPROVAL')) {
			event.preventDefault();
			event.stopPropagation();
			// Forzar el checkbox a su estado anterior
			event.target.checked = group.two_levels_workflow;
			this.setState({
				showUpgradeModal: true,
				upgradeFeature: this.props.t('groups.form.twoLevelApproval')
			});
			return;
		}

		this.setState({
			prevGroup: group,
			group: {
				...group,
				[target]: event.target.checked
			}
		}, () => {
			this._saveGroup();
		});
	}

	handleColorChange = ({ hex }) => {
		const { group } = this.state;

		if (hex === undefined)
			hex = '';

		this.setState({
			group: {
				...group,
				color: hex
			},
			isPickerVisible: false,
		}, () => {
			this._saveGroup();
		});
	}

	handleDateChange = (id, date) => {
		const { group } = this.state;
		let key = id;
		let value = date ? moment(date).format("YYYY-MM-DD") : null;
		this.setState({
			prevGroup: group,
			group: {
				...group,
				[key]: value,
			}
		}, () => {
			this._saveGroup();
		});
	};

	handleBlur = async () => {
		const hasChanged = this.state.group !== this.state.prevGroup;

		if (hasChanged)
			this._saveGroup();
	}

	confirmDelete = async () => {
		const response = await groupsService.remove(this.state.group.id);
		this.closeModal();

		if (response.status === 200)
			this.props.history.goBack();
		else {
			const textError = errorFormating(response);

			this.setState({
				error_footer:
					textError.general ||
					textError.group ||
					textError.id ||
					this.props.t('groups.deleteError')
			});
		}
	}

	_saveGroup = async () => {
		const { group, selected_groups } = this.state;
		// si es multigrup, pasar la lista de grupos por ids
		// console.log(group);

		if (group.is_multigroup && selected_groups.length > 0)
			group.group_ids = selected_groups.map(group => group.id);
		else
			group.group_ids = [];

		const response = await groupsService.update(group);

		if (response.ok) {
			toastr.success(this.props.t('common.success'), this.props.t('common.changesSaved'));

			// Actualizar el estado global de Redux para que otros componentes vean los cambios
			if (Array.isArray(this.props.groups) && this.props.groups.length > 0) {
				const updatedGroups = this.props.groups.map(g =>
					g.id === group.id ? { ...g, ...group } : g
				);

				this.props.dispatch({
					type: "GET_GROUPS",
					payload: updatedGroups,
				});
			}

			// Actualizar el estado local del componente padre
			if (this.props.updateGroup) {
				this.props.updateGroup(group);
			}
		}

		this.setState({
			prevGroup: group,
			errors: errorFormating(response)
		});
	}

	checkValidField = (name) => {
		return (this.state.errors[name] !== undefined && this.state.errors[name] !== '');
	}

	// MULTIGROUPS
	getContent = () => {
		const { group, errors, new_item_error, selected_groups } = this.state;
		const { select_calendars, select_groups } = this.props;

		const optionCalendarList = select_calendars.length > 0 && select_calendars.map((item, i) => {
			return (
				<option key={item.id} value={item.id}>{item.name}</option>
			)
		}, this);

		let empleados_count = this.props.t('groups.noEmployeesAssigned');
		if (group.total_employees === 1)
			empleados_count = this.props.t('groups.oneEmployee');
		else if (group.total_employees > 1)
			empleados_count = `${group.total_employees} ${this.props.t('groups.employeesLabel')}`;


		const onToggleColorPicker = () => { this.setState({ isPickerVisible: !this.state.isPickerVisible }) }
		const isMultigroup = group.is_multigroup;
		const isDrawer = this.props.variant === "drawer";

		return (
			<div className={`tab-info-content${isDrawer ? " tab-info-content--drawer" : ""}`}>
				<Row>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="name">
							<FormLabel>{this.props.t('common.name')} <span className="label-required">*</span></FormLabel>
							<FormControl
								type="text"
								value={group.name}
								onChange={this.handleChange}
								onBlur={this.handleBlur}
								placeholder={this.props.t('groups.info.namePlaceholder')}
								isInvalid={this.checkValidField('name')}
							/>
							<FormControl.Feedback type="invalid">
								{errors.name}
							</FormControl.Feedback>
						</FormGroup>

						<FormGroup className="form-group" controlId="calendar_id">
							<FormLabel>{this.props.t('groups.form.calendar')}</FormLabel>
							<FormControl
								type="text"
								value={group.calendar_id}
								onChange={this.handleChange}
								onBlur={this.handleBlur}
								isInvalid={this.checkValidField('calendar_id')}
								as="select">
								<option value="">{this.props.t('groups.form.selectCalendar')}</option>
								{optionCalendarList}
							</FormControl>

							<FormControl.Feedback type="invalid">
								{errors.calendar_id}
							</FormControl.Feedback>
						</FormGroup>

						<FormGroup controlId="color" className="form-group form-color">
							<div className="flex-between">
								<FormLabel>{this.props.t('groups.form.color')}</FormLabel>
								<FiDelete className={`icon-remove-color ${!group.color && 'hidden'} `} onClick={() => this.handleColorChange("")} />
							</div>
							<FormControl
								type="text"
								value={group.color}
								placeholder={this.props.t('groups.form.color')}
								readOnly
								isInvalid={this.checkValidField('color')}
								style={{ backgroundColor: group.color && group.color }}
								onClick={onToggleColorPicker}
							/>
							<FormControl.Feedback type="invalid">
								{this.state.errors.color}
							</FormControl.Feedback>

							<IoMdColorFill onClick={onToggleColorPicker} />

							{this.state.isPickerVisible && (
								<div style={{ position: 'absolute' }}>
									<TwitterPicker
										color={group.color ? group.color : '#ffffff'}
										onChangeComplete={(hex) => this.handleColorChange(hex)}
									/>
								</div>
							)}
						</FormGroup>

						{!isMultigroup &&
							<FormGroup controlId="published_until" className={`form-group form-date ${(group.published_until === '' || group.published_until === null) && 'empty'}  ${this.checkValidField('published_until') && "is-invalid"}`}>
								<FormLabel>{this.props.t('groups.form.publishedUntil')}</FormLabel>
								<DatePicker
									selected={group.published_until ? moment(group.published_until).toDate() : null}
									onChange={(date) => this.handleDateChange("published_until", date)}
									isInvalid={this.checkValidField("published_until")}
									className="form-control"
									dateFormat="dd/MM/yyyy"
									locale="es"
									placeholderText="dd/mm/aaaa"
								/>

								<FiCalendar />
								<FormControl.Feedback type="invalid">
									{errors.published_until}
								</FormControl.Feedback>
							</FormGroup>
						}

						{!isDrawer && (
						<FormGroup title="No se puede editar" className="form-group form-group-flex form-group-main" controlId="is_multigroup">
							<FormLabel>{this.props.t('groups.form.multigroup')}</FormLabel>
							<Switch
								controlId="is_multigroup"
								isOn={isMultigroup}
								handleToggle={this.handleChange}
								disabled={true}
							/>
						</FormGroup>
						)}

					<FormGroup className="form-group form-group-flex form-group-main" controlId="two_levels_workflow">
						<div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
							<FormLabel style={{ flex: 1 }}>
								{this.props.t('groups.form.secondLevelApproval')}
							</FormLabel>
							<Switch
								controlId="two_levels_workflow"
								isOn={group.two_levels_workflow}
								handleToggle={this.handleSwitch}
							/>
						</div>
					</FormGroup>

					</Col>

					<Col sm={6} md={8} >
						{!isMultigroup ? (
							<>
								<h3 className="subtitle">{this.props.t('groups.info.groupEmployees')}</h3>

								<div className="avatar-container">
									{group.total_employees > 0 &&
										<Avatars employees={group.employees} />
									}
									{empleados_count}
								</div>
							</>
						) : (
							<FormGroup className="form-group" controlId="group_ids">
								<FormLabel>{this.props.t('groups.form.groups')}</FormLabel>
								<GroupsMultiSelect
									groups={select_groups}
									value={selected_groups.map((item) => item.id)}
									onChange={this.handleSelectedGroupsChange}
									isInvalid={new_item_error}
									controlId="group_ids"
								/>
							</FormGroup>
						)}

					</Col>
				</Row>

				{this.state.error_footer &&
					<div className="alert alert-danger alert-dismissible fade show mt15" role="alert">
						{this.state.error_footer}
					</div>
				}

				{!isDrawer && (
				<div className="row-buttons">
					<button type="button" className="btn btn-primary" onClick={this.openPlanModal} >{this.props.t('groups.info.groupPlanBtn')}</button>
					<button type="button" className="btn btn-danger" onClick={this.openDeleteModal} >{this.props.t('groups.info.deleteGroupBtn')}</button>
				</div>
				)}
			</div>
		);
	}
	render() {
		return (
			<>
				{this.getContent()}
				<UpgradeModal
					show={this.state.showUpgradeModal}
					onClose={() => this.setState({ showUpgradeModal: false })}
					feature={this.state.upgradeFeature}
					requiredPlan="Pro"
				/>
			</>
		)
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.calendarsReducer,
		...reducers.groupsReducer,
	}
};


const mapDispatchToProps = dispatch => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }))
	},
	dispatch,
})


export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps), withTranslation())(GroupInfo);
